import { createFromProduct, ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductContext, ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import changeQtyOrdered from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/ChangeQtyOrdered";
import translate from "@insite/client-framework/Translate";
import { AttributeTypeModel, BreakPriceDto, ProductModel } from "@insite/client-framework/Types/ApiModels";
import ProductQuantityBreakPricing, {
    ProductQuantityBreakPricingStyles,
} from "@insite/content-library/Components/ProductQuantityBreakPricing";
import ProductQuantityOrdered from "@insite/content-library/Components/ProductQuantityOrdered";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import DataTable, { DataTablePresentationProps, DataTableProps } from "@insite/mobius/DataTable";
import DataTableBody, { DataTableBodyProps } from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell from "@insite/mobius/DataTable/DataTableCell";
import { DataTableCellBaseProps } from "@insite/mobius/DataTable/DataTableCellBase";
import DataTableHead, { DataTableHeadProps } from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow, { DataTableRowProps } from "@insite/mobius/DataTable/DataTableRow";
import GridContainer, { GridContainerProps, GridOffset, GridWrapper } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Img, { ImgProps } from "@insite/mobius/Img";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import { TextFieldProps } from "@insite/mobius/TextField";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import VariantProductAddToCartButton from "@SupplyLand/Components/VariantProductAddToCartButton";
import { CustomState } from "@SupplyLand/Store/Data/SupplyLand/SupplyLandReducer";
import ProductDetailsAddToCartButton from "@SupplyLand/Widgets/ProductDetails/SupplyLandAddToCartButton";
import ProductDetailsGrandParentVariantOptions from "@SupplyLand/Widgets/ProductDetails/SupplyLandGrandParentVariantOptions";
import ProductDetailsQuantityOrdered from "@SupplyLand/Widgets/ProductDetails/SupplyLandQuantityOrdered";
import ProductDetailsVariantOptions from "@SupplyLand/Widgets/ProductDetails/SupplyLandVariantOptions";
import cloneDeep from "lodash/cloneDeep";
import React, { useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

export interface VariantCardStyles {
    variantCard?: DataTablePresentationProps;
    tableContainer?: InjectableCss;
    priceCell?: InjectableCss;
    modalCell?: InjectableCss;
    header?: InjectableCss;
    productAddToCartButtonStyles?: ButtonPresentationProps;
    productAddToCartButton?: InjectableCss;
    quantityOrdered?: TextFieldProps;
    variantCardRow?: DataTableRowProps;
    basicVariantCardRow?: DataTableRowProps;
    leftTableContent?: InjectableCss;
    rightTableContent?: InjectableCss;
    addToCartColumn?: InjectableCss;
    gridContainer?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    centerColumnGridItem?: GridItemProps;
    rightColumnGridContainer?: GridContainerProps;
    infoGridItem?: GridItemProps;
    variantGridItem?: GridItemProps;
    attributeGridItem?: GridItemProps;
    labelGridItem?: GridItemProps;
    descriptionGridItem?: GridItemProps;
    valueGridItem?: GridItemProps;
    actionsGridItem?: GridItemProps;
    pricesGridItem?: GridItemProps;
    stickyPricesGridItem?: GridItemProps;
    titleGridItem?: GridItemProps;
    searchScoreDataGridItem?: GridItemProps;
    sponsoredText?: TypographyPresentationProps;
    linkWrappingImage?: ClickablePresentationProps;
    img?: ImgProps;
    productDetailDescription?: TypographyProps;
    pricingInfoModal?: ModalPresentationProps;
    pricingTable?: DataTablePresentationProps;
    pricingInfoTableBody?: DataTableBodyProps;
    pricingInfoTableRow?: DataTableRowProps;
    pricingInfoIcon?: IconPresentationProps;
    textItem?: LinkPresentationProps;
    attributeTextItem?: LinkPresentationProps;
    headerTextItem?: LinkPresentationProps;
    textLabel?: LinkPresentationProps;
    stickyGridContainer?: GridContainerProps;
    stickyGridWrapper?: InjectableCss;
    stickyGridItem?: GridItemProps;
    quantityBreakPricing?: ProductQuantityBreakPricingStyles;
    viewLink?: LinkPresentationProps;
    modal?: ModalPresentationProps;
    table?: DataTableProps;
    tableHead?: DataTableHeadProps;
    breakQtyHeader?: DataTableHeaderProps;
    breakPriceHeader?: DataTableHeaderProps;
    savingsHeader?: DataTableHeaderProps;
    tableBody?: DataTableBodyProps;
    tableRow?: DataTableRowProps;
    breakQtyCell?: DataTableCellBaseProps;
    breakPriceCell?: DataTableCellBaseProps;
    savingsCell?: DataTableCellBaseProps;
    priceBreaksClickable?: ClickablePresentationProps;
}

const qtyPerAttribute = [
    "Bags_Per_Roll_Packaging",
    "Bundle_Qty_Packaging",
    "Cans_Per_Case_Janitorial",
    "Labels_Per_Pack",
    "Labels_Per_Roll_Packaging",
    "PairsPerCase",
    "QtyPerBag",
    "Qty_Per_Bag__Facility_Operations",
    "Qty_Per_Box",
    "Qty_Per_Box_Facility_Operations",
    "Qty_Per_Box_Janitorial",
    "Qty_Per_Box_Safety",
    "QtyPerBundle",
    "Qty_Per_Case_Facility_Operations",
    "Qty_Per_Case_Janitorial",
    "Qty_Per_Case_Packaging",
    "Qty_Per_Case_Safety",
    "Qty_Per_Pack_Facility_Operations",
    "Qty_Per_Pack_Janitorial",
    "Qty_Per_Pack_Packaging",
    "Qty_Per_Pack_Safety",
    "Rolls_Per_Bundle_Packaging",
    "Rolls_Per_Case_Janitorial",
    "Rolls_Per_Case_Packaging",
    "Sheets_Per_Bundle_Packaging",
    "Sheets_Per_Can_Janitorial",
    "Sheets_Per_Case_Janitorial",
    "Sheets_Per_Roll_Janitorial",
    "WipersPerPail",
    "WipersPerRoll",
    "Wipes_Per_Box_Janitorial",
];

export const variantCardStyles: VariantCardStyles = {
    gridContainer: {
        gap: 0,
        css: css`
            min-width: 320px; /* prevent overlap with second column */
        `,
    },
    stickyGridContainer: {
        css: css`
            position: fixed;
            bottom: 0px;
            left: 0;
            right: 0;
            z-index: 1240;
            background: whitesmoke;
            display: flex;
            justify-content: center !important;
            max-width: 100% !important;
            padding: 20px !important;
        `,
    },
    stickyGridWrapper: {
        css: css`
            justify-content: space-between;
            max-width: 100%;
            padding: 20px;
        `,
    },
    stickyGridItem: {
        width: 12,
        css: css`
            position: fixed;
            bottom: 0px;
            left: 0;
            right: 0;
            z-index: 1240;
            background: whitesmoke;
            display: flex;
            justify-content: center;
            align-items: center;
        `,
    },
    tableContainer: {
        css: css`
            overflow-x: auto;
            margin-bottom: 10px;
        `,
    },
    variantCard: {
        css: css`
            td {
                border: 0.5px solid black;
                text-align: center;
            }
            th {
                border: 0.5px solid black;
                text-align: center;
                max-width: 130px;
                white-space: normal;
                background: rgb(251 241 200);
            }
        `,
    },
    rightColumnGridContainer: {
        css: css`
            align-items: center;
            justify-content: center;
            margin: 15px !important;
        `,
    },
    leftColumnGridItem: {
        width: [4, 4, 4, 3, 3],
        css: css`
            padding-right: 20px;
            flex-direction: column;
            align-items: center;
        `,
    },
    rightColumnGridItem: {
        width: [8, 8, 8, 9, 9],
        css: css`
            align-items: center;
        `,
    },
    centerColumnGridItem: {
        width: 12,
        css: css`
            align-items: center;
            justify-content: center;
        `,
    },
    infoGridItem: {
        width: [12, 12, 12, 7, 7],
    },
    actionsGridItem: {
        width: 12,
        css: css`
            justify-content: space-evenly;
            align-items: center;
            padding-left: 0px;
            padding-right: 5px;
        `,
    },
    titleGridItem: {
        width: 12,
        css: css`
            padding: 5px;
            justify-content: left;
            align-items: baseline;
        `,
    },
    attributeGridItem: {
        width: 12,
        css: css`
            justify-content: left;
            align-items: baseline;
            padding: 5px;
        `,
    },
    pricesGridItem: {
        width: 12,
        css: css`
            padding: 0 4px 0 4px;
            color: green;
            justify-content: left;
            align-items: baseline;
        `,
    },
    stickyPricesGridItem: {
        width: 12,
        css: css`
            padding: 5px;
            color: green;
            justify-content: center;
            align-items: baseline;
        `,
    },
    labelGridItem: {
        width: 6,
        css: css`
            padding-right: 20px;
            flex-direction: column;
            padding: 5px;
        `,
    },
    descriptionGridItem: {
        width: 12,
        css: css`
            padding-right: 20px;
            flex-direction: column;
            padding: 5px;
        `,
    },
    valueGridItem: {
        width: 6,
        css: css`
            padding-right: 20px;
            flex-direction: column;
            padding: 5px;
        `,
    },
    searchScoreDataGridItem: {
        width: 12,
    },
    variantGridItem: {
        width: [12, 12, 12, 12, 12],
    },
    sponsoredText: {
        css: css`
            margin-bottom: 5px;
            font-size: 0.9em;
            opacity: 0.5;
        `,
    },
    variantCardRow: {
        css: css`
            background: white;
            a {
                text-decoration: underline;
            }
        `,
        evenRowCss: css`
            background: rgb(251 241 200);
        `,
    },
    basicVariantCardRow: {
        css: css`
            background: white;
            a {
                text-decoration: underline;
            }
        `,
        evenRowCss: css`
            background: white;
        `,
    },
    linkWrappingImage: {
        css: css`
            width: 100%;
        `,
    },
    img: {
        css: css`
            height: auto;
            width: 100%;
        `,
    },
    priceCell: {
        css: css`
            border-left: none !important;
            border-right: none !important;
            background: none;
            text-align: center;
        `,
    },
    modalCell: {
        css: css`
            text-align: center;
        `,
    },
    header: {
        css: css`
            border-bottom: 0px solid !important;
        `,
    },
    productAddToCartButtonStyles: {
        css: css`
            color: ${getColor("secondary")};
            box-shadow: 2px 2px 2px rgb(0 0 0 / 60%);
            background: ${getColor("primary")};
            margin-left: 0px;
            margin-right: 0px;
            border-radius: 8px;
        `,
    },
    productAddToCartButton: {
        css: css`
            color: ${getColor("secondary")};
            box-shadow: 2px 2px 2px rgb(0 0 0 / 60%);
            background: ${getColor("primary")};
            margin-left: 20px;
            margin-right: 20px;
            border-radius: 8px;
        `,
    },
    quantityOrdered: {
        cssOverrides: {
            formField: css`
                margin-right: 10px;
                width: 7rem;
                min-width: 4.1rem;
                padding-left: 15px;
                text-align-last: center;
            `,
        },
    },
    leftTableContent: {
        css: css`
            font-weight: bold;
            float: left;
        `,
    },
    rightTableContent: {
        css: css`
            float: right;
        `,
    },
    addToCartColumn: {
        css: css`
            min-width: 250px;
        `,
    },
    pricingTable: {
        css: css`
            td {
                border: 0.5px solid black;
                text-align: center;
            }
            th {
                border: 0.5px solid black;
                text-align: center;
                max-width: 130px;
                white-space: normal;
                background: rgb(251 241 200);
            }
        `,
    },
    pricingInfoIcon: {
        color: "info",
        css: css`
            margin-left: 10px;
        `,
    },
    quantityBreakPricing: {
        viewLink: {
            css: css`
                margin: 8px 0 0 20px;
            `,
        },
    },
    textItem: {
        css: css`
            font-weight: bold;
            padding-right: 5px;
        `,
    },
    attributeTextItem: {
        css: css`
            font-weight: bold;
            padding-right: 5px;
        `,
    },
    headerTextItem: {
        css: css`
            font-weight: bold;
            width: 100%;
            text-align: left;
            display: inline-block;
            padding: 5px;
        `,
    },
    textLabel: {
        css: css`
            text-transform: uppercase;
        `,
    },
    modal: {
        size: 400,
        cssOverrides: {
            modalContent: css`
                padding: 0;
            `,
            modalTitle: css`
                padding: 10px 10px 10px 20px;
            `,
            headlineTypography: css`
                font-size: 20px;
                margin-bottom: 0;
            `,
        },
    },
    breakQtyHeader: {
        alignX: "center",
        css: css`
            background: rgb(251 241 200);
        `,
    },
    breakPriceHeader: {
        alignX: "center",
        css: css`
            background: rgb(251 241 200);
        `,
    },
    savingsHeader: { alignX: "center" },
    breakQtyCell: { alignX: "center" },
    breakPriceCell: { alignX: "center" },
    savingsCell: { alignX: "center" },
    tableHead: {
        css: css`
            background: rgb(251 241 200);
        `,
    },
    tableRow: {
        css: css`
            background: white;
            a {
                text-decoration: underline;
            }
        `,
        evenRowCss: css`
            background: rgb(251 241 200);
        `,
    },
    priceBreaksClickable: {
        css: css`
            align-self: center;
            padding-left: 2px;
        `,
    },
};

const styles = variantCardStyles;

const mapStateToProps = (state: CustomState) => {
    return {
        productData: state.data.products,
        productInfoData: state.pages.productDetails,
        variantSelection: state.pages.productDetails.variantSelection,
        pricing: state.supplyLandData.variantPrices,
    };
};

const mapDispatchToProps = {
    changeQtyOrdered,
};

interface OwnProps {
    product: ProductModel;
    parentProductId: string;
    variantChildren: ProductModel[];
    priceHeaders: string[];
}

const Separator = styled.hr`
    border: 1px solid #9b9b9b;
    opacity: 0.5;
    margin-top: 10px;
    margin-bottom: 20px;
    width: 100%;
`;

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps;
const ProductListMobileCard: React.FC<Props> = props => {
    const [infoModalIsOpen, setInfoModalIsOpen] = useState(false);
    const [modalInfoData, setModalInfoData] = useState({} as ProductModel);
    const variantChildren = props.variantChildren;

    const modalCloseHandler = () => {
        setInfoModalIsOpen(false);
    };

    const openPricingInfoModal = (child: ProductModel) => {
        setModalInfoData(child);
        setInfoModalIsOpen(true);
    };

    const renderVariantCard = () => {
        const getVariantColumns = (child: ProductModel) => {
            if (isParentChildConnector && parentProduct.variantTraits && parentProduct.variantTraits.length > 1) {
                const connectorTrait = child.childTraitValues?.find(trait => trait.value === child.productNumber);
                if (connectorTrait && child.childTraitValues) {
                    return (
                        <ProductDetailsGrandParentVariantOptions
                            isTable={false}
                            childTraits={child.childTraitValues}
                            connectorTrait={connectorTrait}
                            optionKeyPart={child.productNumber}
                        ></ProductDetailsGrandParentVariantOptions>
                    );
                }
            }
            if (
                !isParentChildConnector &&
                parentProduct.variantTraits !== undefined &&
                parentProduct.variantTraits.length > 0
            ) {
                return <ProductDetailsVariantOptions isTable={false}></ProductDetailsVariantOptions>;
            }
            return null;
        };

        const getAttributeColumns = (child: ProductModel, attributeHeaders: string[]) => {
            if (attributeHeaders.length === 0) {
                return null;
            }

            const attributeColumns = [] as AttributeTypeModel[];

            let id = child.id;

            if (parentProduct.productNumber === child.productNumber) {
                id = child.id;
            }

            const attributeResults: JSX.Element[] = [];

            if (!singleProductPage) {
                attributeResults.push(
                    <GridItem {...styles.titleGridItem}>
                        <Typography {...styles.textItem}>{child.productTitle}</Typography>
                    </GridItem>,
                );
            }
            attributeHeaders.forEach(attributeName => {
                const childAttributes = child.attributeTypes;
                if (childAttributes) {
                    const attributeColumn = childAttributes.find(
                        (attribute: AttributeTypeModel) => attribute.label === attributeName,
                    );
                    if (attributeColumn?.attributeValues && qtyPerAttribute.includes(attributeColumn.name)) {
                        attributeColumns.push(attributeColumn);
                        attributeResults.push(
                            <GridItem {...styles.attributeGridItem}>
                                <Typography {...styles.attributeTextItem}>{attributeColumn.label}:</Typography>
                                <Typography {...styles.attributeTextItem}>
                                    {attributeColumn.attributeValues[0].valueDisplay}
                                </Typography>
                            </GridItem>,
                        );
                    } else {
                        return null;
                    }
                }
            });

            return <>{attributeResults}</>;
        };

        const getPriceForModal = (product: ProductModel) => {
            if (props.productInfoData.productInfosById) {
                const pricing = props.pricing[product.id];

                if (product.minimumOrderQty) {
                    props.priceHeaders[0] = "1";
                }

                const priceColumns = [] as string[];

                const priceArray = [<></>];
                props.priceHeaders.forEach((priceBreak, index) => {
                    const priceBreakValue = priceBreak.replace("+", "");
                    const price = pricing?.actualBreakPrices?.find(x => x.breakQty.toString() === priceBreakValue);
                    let priceDisplay = "N/A";
                    if (price) {
                        priceColumns.push(price.breakPriceDisplay);
                        priceDisplay = price.breakPriceDisplay;
                    } else {
                        priceColumns.push("N/A");
                    }
                    priceArray.push(
                        <DataTableRow
                            {...styles.tableRow}
                            key={priceBreakValue + index}
                            data-test-selector="breakPriceRow"
                        >
                            <DataTableCell {...styles.modalCell} key={`${priceBreakValue + product.id}-mobile`}>
                                {priceBreakValue}
                            </DataTableCell>
                            <DataTableCell {...styles.modalCell} key={`${price + product.id}-mobile-${index}`}>
                                {priceDisplay}
                            </DataTableCell>
                        </DataTableRow>,
                    );
                });
                return priceArray;
            }
            return <DataTableCell> </DataTableCell>;
        };

        const getPriceColumns = (product: ProductModel) => {
            const childPricing = props.pricing[product.id];
            if (!childPricing || !childPricing.actualBreakPrices) {
                return props.priceHeaders.map((header, index) => (
                    <Typography {...styles.priceCell} key={`${header + product.id}-mobile-${index}`}>
                        {Math.round((props.priceHeaders.length - 1) / 2) === index ? (
                            <LoadingSpinner size={15} />
                        ) : (
                            <></>
                        )}
                    </Typography>
                ));
            }

            if (product.minimumOrderQty) {
                props.priceHeaders[0] = "1";
            }

            const priceColumns = [] as string[];

            props.priceHeaders.forEach(priceBreak => {
                priceBreak = priceBreak.replace("+", "");
                const price = childPricing.actualBreakPrices?.find(x => x.breakQty.toString() === priceBreak);
                if (price) {
                    priceColumns.push(price.breakPriceDisplay);
                } else {
                    priceColumns.push("N/A");
                }
            });

            let priceDisplayValue = priceColumns[0];

            if (uomDisplay && uomDisplay.length > 0) {
                priceDisplayValue = `Starting at ${priceDisplayValue} ${uomDisplay}`;
            } else {
                const uom =
                    modalInfoData && product?.unitOfMeasures && product.unitOfMeasures.length > 0
                        ? product.unitOfMeasures[0].unitOfMeasureDisplay
                        : "";
                priceDisplayValue = `Starting at ${priceDisplayValue} ${uomDisplay}`;
            }

            return priceColumns.length > 0 ? (
                <Typography {...styles.textItem} key={`productPrice${product.id}-mobile`}>
                    {priceDisplayValue}
                </Typography>
            ) : null;
        };

        const variantChildActions = (variantChild: ProductModel) => {
            const product = props.productData.byId[variantChild.id];
            let productInfo = createFromProduct(product) as ProductInfo;
            if (props.productInfoData.productInfosById) {
                const variantProductInfo = cloneDeep(props.productInfoData.productInfosById[variantChild.id]);
                if (variantProductInfo) {
                    productInfo = variantProductInfo;
                }
            }
            const productContext: ProductContextModel = {
                product,
                productInfo,
                onQtyOrderedChanged: qtyOrdered => {
                    props.changeQtyOrdered({ qtyOrdered, productId: product.id });
                },
                onUnitOfMeasureChanged: unitOfMeasure => {
                    productInfo.unitOfMeasure = unitOfMeasure;
                },
            };
            let grandparentSelectionComplete = true;
            const connectorId = variantParent?.variantTraits?.find(
                variant => variant.nameDisplay === "Parent Child Connector",
            )?.id;
            if (connectorId) {
                variantParent.variantTraits
                    ?.filter(trait => trait.name !== "Parent Child Connector")
                    .forEach(trait => {
                        if (
                            props.variantSelection[
                                trait.id +
                                    product.childTraitValues?.find(trait => trait.styleTraitId === connectorId)?.value
                            ]
                        ) {
                            grandparentSelectionComplete = true;
                        } else {
                            grandparentSelectionComplete = false;
                        }
                    });
            }

            return (
                <ProductContext.Provider value={productContext}>
                    <VisuallyHidden as="label" htmlFor={`${variantChild.id}-qty`} id={`${variantChild.id}-qty-label`}>
                        {translate("QTY")}
                    </VisuallyHidden>
                    <ProductQuantityOrdered
                        labelOverride=""
                        extendedStyles={styles.quantityOrdered}
                        variantSelectionCompleted={grandparentSelectionComplete}
                        id={`${variantChild.id}-qty`}
                    />
                    <VariantProductAddToCartButton
                        variantSelectionCompleted={grandparentSelectionComplete}
                        labelOverride="Add"
                        data-test-selector={`actionsAddToCart${variantChild.id}`}
                        extendedStyles={styles.productAddToCartButtonStyles}
                        product={variantChild}
                    />
                </ProductContext.Provider>
            );
        };

        let variantParent = props.productData.byId[props.product.id];
        if (!props.product.isVariantParent) {
            variantParent = props.productData.byId[props.parentProductId];
        }
        if (!variantParent) {
            return null;
        }

        if (variantParent.variantTraits == null) {
            return null;
        }

        const parentProduct = variantParent;
        const isParentChildConnector = parentProduct.variantTraits?.some(variant => (variant.nameDisplay === "Parent Child Connector")) || parentProduct.productNumber === "KraftBoxes";
        
        const singleProductPage =
            (isParentChildConnector && variantChildren.length === 1) ||
            (!isParentChildConnector && props.product.isVariantParent) ||
            (!isParentChildConnector && !props.product.isVariantParent);

        const columnStyling = singleProductPage ? styles.centerColumnGridItem : styles.rightColumnGridItem;

        let attributeNames: string[] = [];
        if (parentProduct.properties && parentProduct.properties["displayedAttributes"] != null) {
            attributeNames = parentProduct.properties["displayedAttributes"].split(",");
            const trimmedNames: string[] = [];
            attributeNames.forEach(name => {
                const trimmedName = name.trim();
                trimmedNames.push(trimmedName);
            });
            attributeNames = trimmedNames;
        }
        const rightTableContent = props.productData.byId[props.product.id].properties["table_Header_Right"];
        const actionsStyle = variantChildren.length === 1 ? styles.stickyGridItem : styles.actionsGridItem;

        const productUnitOfMeasure =
            parentProduct && parentProduct.properties && "table_Price_Break_UoM" in parentProduct.properties
                ? parentProduct.properties["table_Price_Break_UoM"]
                : undefined;
        let uomDisplay = "";
        if (productUnitOfMeasure && productUnitOfMeasure.length > 0) {
            uomDisplay = productUnitOfMeasure.replace("Price Per ", "/ ");
            uomDisplay = uomDisplay.replace("Price ", "/ ");
        }
        return (
            <>
                {rightTableContent && rightTableContent.length > 0 && (
                    <Typography {...styles.headerTextItem}>{rightTableContent}</Typography>
                )}
                {variantChildren?.map(child => (
                    <div key={`gridcontainerdiv${child.id}`}>
                        <GridContainer {...styles.gridContainer}>
                            {!singleProductPage && (
                                <GridItem {...styles.leftColumnGridItem} key={`imggriditem${child.id}`}>
                                    <Clickable
                                        {...styles.linkWrappingImage}
                                        href={props.productData.byId[child.id]?.canonicalUrl}
                                        data-test-selector="productImage"
                                        key={`productimgclickable${child.id}`}
                                    >
                                        <Img
                                            {...styles.img}
                                            key={`productimg${child.id}`}
                                            loading=""
                                            width="209"
                                            height="209"
                                            src={props.productData.byId[child.id]?.smallImagePath}
                                            altText=""
                                        />
                                    </Clickable>
                                    <Typography
                                        key={`productNumber${props.productData.byId[child.id]?.productNumber}`}
                                        {...styles.priceCell}
                                    >
                                        {child.productNumber}
                                    </Typography>
                                </GridItem>
                            )}
                            <GridItem {...columnStyling} key={`productinfogriditem${child.id}`}>
                                <GridContainer
                                    {...styles.rightColumnGridContainer}
                                    key={`productinfogridcontainer${child.id}`}
                                >
                                    {getVariantColumns(child)}
                                    {getAttributeColumns(child, attributeNames)}
                                    {!singleProductPage && (
                                        <>
                                            <GridItem
                                                {...styles.pricesGridItem}
                                                key={`productinfosingleProduct${child.id}`}
                                            >
                                                {getPriceColumns(child)}
                                            </GridItem>
                                        </>
                                    )}
                                    {isParentChildConnector && variantChildren.length > 1 && (
                                        <GridItem {...actionsStyle} key={`productinfopricinggriditem${child.id}`}>
                                            <Clickable
                                                {...styles.priceBreaksClickable}
                                                onClick={() => openPricingInfoModal(child)}
                                            >
                                                {translate("Price Breaks")}
                                            </Clickable>
                                            {variantChildActions(child)}
                                        </GridItem>
                                    )}
                                    {isParentChildConnector && variantChildren.length === 1 && (
                                        <GridContainer {...styles.stickyGridContainer}>
                                            <GridItem {...styles.stickyPricesGridItem} key={`stickyPrices${child.id}`}>
                                                {getPriceColumns(child)}
                                                <Clickable onClick={() => openPricingInfoModal(child)}>
                                                    &nbsp;{translate("Price Breaks")}
                                                </Clickable>
                                            </GridItem>
                                            <GridItem {...styles.centerColumnGridItem} key={`centerColumn${child.id}`}>
                                                {variantChildActions(child)}
                                            </GridItem>
                                        </GridContainer>
                                    )}
                                    {!isParentChildConnector && props.product.isVariantParent && (
                                        <GridContainer {...styles.stickyGridContainer}>
                                            <GridItem {...styles.stickyPricesGridItem} key={`stickyPrices${child.id}`}>
                                                {getPriceColumns(child)}
                                                <Clickable onClick={() => openPricingInfoModal(child)}>
                                                    &nbsp;{translate("Price Breaks")}
                                                </Clickable>
                                            </GridItem>
                                            <GridItem {...styles.centerColumnGridItem} key={`centerColumn${child.id}`}>
                                                <ProductQuantityOrdered
                                                    disabled={true}
                                                    labelOverride=""
                                                    extendedStyles={styles.quantityOrdered}
                                                    variantSelectionCompleted={false}
                                                    configurationCompleted={true}
                                                    id={`${child.id}-qty`}
                                                />
                                                <Button disabled={true} {...styles.productAddToCartButton}>
                                                    {translate("Add")}
                                                </Button>
                                            </GridItem>
                                        </GridContainer>
                                    )}
                                    {!isParentChildConnector && !props.product.isVariantParent && (
                                        <GridContainer {...styles.stickyGridContainer}>
                                            <GridItem {...styles.stickyPricesGridItem} key={`stickyPrices${child.id}`}>
                                                {getPriceColumns(child)}
                                                <Clickable onClick={() => openPricingInfoModal(child)}>
                                                    &nbsp;{translate("Price Breaks")}
                                                </Clickable>
                                            </GridItem>
                                            <GridItem {...styles.centerColumnGridItem} key={`centerColumn${child.id}`}>
                                                <ProductDetailsQuantityOrdered />
                                                <ProductDetailsAddToCartButton
                                                    data-test-selector={`actionsAddToCart${child.id}`}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                    )}
                                </GridContainer>
                            </GridItem>
                            {!singleProductPage && <Separator key={`separator${child.id}`} />}
                        </GridContainer>
                    </div>
                ))}
                <Modal
                    {...styles.modal}
                    headline={translate("Quantity Pricing")}
                    isOpen={infoModalIsOpen}
                    handleClose={modalCloseHandler}
                    data-test-selector="quantityBreakPricingModal"
                >
                    <DataTable {...styles.table}>
                        <DataTableHead {...styles.tableHead}>
                            <DataTableHeader {...styles.breakQtyHeader}>{translate("Qty Breaks")}</DataTableHeader>
                            <DataTableHeader {...styles.breakPriceHeader}>
                                {parentProduct &&
                                parentProduct?.properties &&
                                "table_Price_Break_UoM" in parentProduct.properties
                                    ? parentProduct?.properties["table_Price_Break_UoM"]
                                    : modalInfoData &&
                                      modalInfoData?.unitOfMeasures &&
                                      modalInfoData.unitOfMeasures.length > 0
                                    ? modalInfoData.unitOfMeasures[0].unitOfMeasureDisplay
                                    : ""}
                            </DataTableHeader>
                        </DataTableHead>
                        <DataTableBody {...styles.tableBody}>{getPriceForModal(modalInfoData)}</DataTableBody>
                    </DataTable>
                </Modal>
            </>
        );
    };
    return <StyledWrapper {...styles.gridContainer}>{renderVariantCard()}</StyledWrapper>;
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductListMobileCard);
